// extracted by mini-css-extract-plugin
export default {"wrapper":"Team_wrapper__KjOF1","content":"Team_content__V3mYZ","title":"Team_title__qjif4","text":"Team_text__O2XKV","swiper":"Team_swiper__wFDwf"};